import { useState, useEffect, useContext } from "react";
import { Panel, PanelBody, PanelHeader } from "../../components/panel/panel";
import LoadingAnimation from "../loading/loading";
import { FloatingEmailInput } from "../reusable-elements/floating-email-input";
import { FloatingTextInput } from "../reusable-elements/floating-text-input";
import { validEmail, notNullOrEmpty, validUKPhoneNumber, validateField } from "../../utils/validators";
import { Table } from 'react-bootstrap';
import { UnsocialHours } from './unsocial-hours';
import { UserContext } from "../../pages/user/user-settings";

export const UserDetailsTab = () => {

    const { myProfile, setMyProfile, setValidationErrors, self, userApi } = useContext(UserContext);
    const [imageDimensions, setImageDimensions] = useState(null);
    const [availableRoles, setAvailableRoles] = useState([]);
    const [isLoadingRoles, setIsLoadingRoles] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');

    useEffect(() => {
        if (!imageDimensions && !!myProfile) {
            const img = new Image();
            img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;

                setImageDimensions({ width, height });
            };
            img.src = myProfile.thumbnailProfileImageIncludingSasToken;
        }

    }, [myProfile, imageDimensions]);

    useEffect(() => {
        const fetchAvailableRoles = async () => {
            if (myProfile && myProfile.id) {
                setIsLoadingRoles(true);
                try {
                    const result = await userApi.getApiRoles();
                    setAvailableRoles(result);
                } catch (error) {
                    console.error('Error fetching roles:', error);
                } finally {
                    setIsLoadingRoles(false);
                }
            }
        };
        fetchAvailableRoles();
    }, [myProfile?.id]);

    const validateState = newState => {
        // Validate fields that the user can change and that you care about the contents of
        validateField(() => newState.phoneNumber && newState.phoneNumber.length > 0 && validUKPhoneNumber(newState.phoneNumber), () => newState.phoneNumber, setValidationErrors);
    };

    const handleStateUpdates = updateMethod => {
        const newState = updateMethod(structuredClone(myProfile));
        validateState(newState);
        setMyProfile(newState);
    };

    const imageStyle = user => {
        const unknown = { alignSelf: "center", width: "50%", backgroundImage: 'url(/assets/img/user/user-6.jpg)' };
        const known = { borderRadius: "50%", backgroundRepeat: "no-repeat", width: `${imageDimensions ? imageDimensions.width : 128}px`, height: `${imageDimensions ? imageDimensions.height : 128}px`, backgroundImage: `url(${user.thumbnailProfileImageIncludingSasToken})` };
        return !!user && !!user.thumbnailProfileImageIncludingSasToken ? known : unknown;
    }

    const addRoleToUser = () => {
        if (!selectedRole || !!self) return;

        if (!myProfile.apiRoles.includes(selectedRole)) {
            handleStateUpdates(v => {
                v.apiRoles = [...v.apiRoles, selectedRole];
                return v;
            });
            setSelectedRole('');
        }
    };

    const removeRoleFromUser = roleToRemove => {
        if (!!self) return;
        handleStateUpdates(v => {
            v.apiRoles = v.apiRoles.filter(role => role !== roleToRemove);
            return v;
        });
    };

    const tableAppRoleRows = myProfile && myProfile.apiRoles ? myProfile.apiRoles.map((roleName, index) => {
        // Find matching role in availableRoles to get description
        const matchingRole = availableRoles && availableRoles.length > 0 ?
            availableRoles.find(role => role.name.toLowerCase() === roleName.toLowerCase()) : null;
        const displayText = matchingRole ? matchingRole.description : roleName;

        return (
            <tr key={`roleKey-${index}`}>
                <td>{index}</td>
                <td>{displayText}</td>
                {!!!self && <td>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => removeRoleFromUser(roleName)}
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </td>}
            </tr>
        );
    }) : <tr key={"key"}>
        <td>Loading...</td>
        <td>Loading...</td>
        <td></td>
    </tr>;

    return !!myProfile ? (
        <>
            <div className="row mb-3">
                <div className="col-xl-4" key={"Details"}>
                    <Panel
                        showReload={false}
                        showDelete={false}
                    >
                        <PanelHeader>Profile</PanelHeader>
                        <PanelBody>
                            <div className="row mb-15px">
                                <label className="form-label col-form-label col-md-3">Profile Image</label>
                                <div className={'col-md-9'}>
                                    {!!myProfile && !!myProfile.thumbnailProfileImageIncludingSasToken && <div className="img" style={imageStyle(myProfile)}></div>}
                                    {!(!!myProfile && !!myProfile.thumbnailProfileImageIncludingSasToken) && <>Please select your profile image and crop it appropriately</>}
                                </div>
                            </div>

                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.displayName ? "Enter" : ""} Display Name`}
                                text={myProfile.displayName}
                                updateCallback={newValue => { handleStateUpdates(v => { v.displayName = newValue; return v; }) }}
                                validatorFn={() => { return notNullOrEmpty(myProfile.displayName); }}

                            />

                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.givenName ? "Enter" : ""} First Name`}
                                text={myProfile.givenName}
                                updateCallback={newValue => { handleStateUpdates(v => { v.givenName = newValue; return v; }) }}
                                validatorFn={() => { return notNullOrEmpty(myProfile.givenName); }}

                            />

                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.surname ? "Enter" : ""} Last Name`}
                                text={myProfile.surname}
                                updateCallback={newValue => { handleStateUpdates(v => { v.surname = newValue; return v; }) }}
                                validatorFn={() => { return notNullOrEmpty(myProfile.surname); }}

                            />

                            <FloatingEmailInput
                                className={"mt-1"}
                                label={`${!myProfile.emailAddress ? "Enter" : ""} Email Address`}
                                email={myProfile.emailAddress}
                                updateCallback={newValue => { handleStateUpdates(v => { v.emailAddress = newValue; return v; }) }}
                                validatorFn={() => { return notNullOrEmpty(myProfile.emailAddress) && validEmail(myProfile.emailAddress); }}
                                readOnly={true}
                            />

                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.telegramChatId ? "Enter" : ""} Telegram Chat Id`}
                                text={myProfile.telegramChatId}
                                updateCallback={newValue => { handleStateUpdates(v => { v.telegramChatId = newValue; return v; }) }}
                                readOnly={true}
                                validatorFn={() => { return notNullOrEmpty(myProfile.telegramChatId); }}
                            />
                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.phoneNumber ? "Enter" : ""} Phone Number`}
                                text={myProfile.phoneNumber}
                                updateCallback={newValue => { handleStateUpdates(v => { v.phoneNumber = newValue; return v; }) }}
                                validatorFn={() => { return notNullOrEmpty(myProfile.phoneNumber) && validUKPhoneNumber(myProfile.phoneNumber); }}
                                required={false}
                            />
                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.jobTitle ? "Enter" : ""} Job Title`}
                                text={myProfile.jobTitle}
                                updateCallback={newValue => { handleStateUpdates(v => { v.jobTitle = newValue; return v; }) }}
                                validatorFn={() => { return notNullOrEmpty(myProfile.jobTitle) }}
                                required={false}
                            />
                            <FloatingTextInput
                                className={"mt-1"}
                                label={`${!myProfile.locale ? "Enter" : ""} Locale`}
                                text={myProfile.locale}
                                updateCallback={newValue => { handleStateUpdates(v => { v.locale = newValue; return v; }) }}
                                //validatorFn={() => { return notNullOrEmpty(myProfile.locale); }}
                                validatorFn={() => { return true; }}
                                required={false}
                            />
                        </PanelBody>
                    </Panel>
                </div>

                <div className="col-xl-4" key={"Roles"}>
                    <Panel
                        showReload={false}
                        showDelete={false}
                    >
                        <PanelHeader>Roles</PanelHeader>
                        <PanelBody>
                            <div className="data-area-div">
                                <p>
                                    Manage your <strong>Application Roles</strong> below.
                                </p>
                                {!!!self && !!!isLoadingRoles ? <>
                                    <div className="mb-3">
                                        <div className="input-group">
                                            <select
                                                className="form-select"
                                                value={selectedRole}
                                                onChange={(e) => setSelectedRole(e.target.value)}
                                                disabled={isLoadingRoles}
                                            >
                                                <option value="">Select a role to add</option>
                                                {availableRoles.map((role, index) => (
                                                    <option key={index} value={role.name}>
                                                        {role.description}
                                                    </option>
                                                ))}
                                            </select>
                                            <button
                                                className="btn btn-primary"
                                                onClick={addRoleToUser}
                                                disabled={!selectedRole || isLoadingRoles}
                                            >
                                                Add Role
                                            </button>
                                        </div>
                                    </div>

                                    <div className="data-area-div">
                                        <Table responsive striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Number</th>
                                                    <th>Role</th>
                                                    {!!!self && <th>Action</th>}
                                                </tr>
                                            </thead>
                                            <tbody>{tableAppRoleRows}</tbody>
                                        </Table>
                                    </div>
                                </>
                                    :
                                    <>
                                        {!!self && !!!isLoadingRoles ?
                                            <>You cant edit your own roles!</>
                                            :
                                            <LoadingAnimation />
                                        }
                                    </>
                                }
                            </div>
                        </PanelBody>
                    </Panel>
                </div>

                <div className="col-xl-4" key={"UnsocialHours"}>
                    <Panel
                        showReload={false}
                        showDelete={false}
                    >
                        <PanelHeader>Unsocial Hours (Do Not Disturb)</PanelHeader>
                        <PanelBody>
                            <UnsocialHours />
                        </PanelBody>
                    </Panel>
                </div>
            </div>

        </>
    )
        :
        <LoadingAnimation />
};